import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-password',
  providers: [],
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
  passwordConfig: IPasswordConfig = {
    passwordExpirationDays: 0,
    passwordResetDays: 0
  };

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.getPasswordConfig();
  }

  getPasswordConfig(): void {
    this.http.get<IPasswordConfig>('Config/GetPasswordConfig').subscribe({
      next: passwordConfig => {
        this.passwordConfig = passwordConfig;
      },
      error: error => {
        console.error('Error getting password configuration', error);
      }
    });
  }

  setPasswordConfig(): void {
    this.http.put('Config/SetPasswordConfig', this.passwordConfig).subscribe({
      next: () => {
        // update password config after set
        this.getPasswordConfig();
      },
      error: error => {
        console.error('Error setting password configuration', error);
      }
    });
  }
}

export interface IPasswordConfig {
  passwordExpirationDays: number;
  passwordResetDays: number;
}